import React from 'react';

const Signup = React.lazy(() => import('views/auth/signup/account').then(m => ({ default: m.Signup })));
const OauthRedirect = React.lazy(() => import('views/auth/OauthRedirect'));
const SignupUser = React.lazy(() => import('views/auth/signup/user').then(m => ({ default: m.SignupUser })));
const Signin = React.lazy(() => import('views/auth/signin').then(m => ({ default: m.Signin })));
const SigninOTP = React.lazy(() => import('views/auth/signin/otp').then(m => ({ default: m.SigninOTP })));
const SocialSignin = React.lazy(() => import('views/auth/signin/social').then(m => ({ default: m.SocialSignin })));
const ForgotPassword = React.lazy(() => import('views/auth/signin/forgotpassword').then(m => ({ default: m.ForgotPassword })));
const ResetPassword = React.lazy(() => import('views/auth/signin/resetpassword').then(m => ({ default: m.ResetPassword })));
const MagicSignin = React.lazy(() => import('views/auth/signin/magic').then(m => ({ default: m.MagicSignin })));
const ImpersonateSignin = React.lazy(() => import('views/auth/signin/impersonate').then(m => ({ default: m.ImpersonateSignin })));
const PhonePage = React.lazy(() => import('views/auth/signup/phonepage'));
const OnboardingSteps = React.lazy(() => import('views/onboarding/steps').then(m => ({ default: m.OnboardingSteps })));

const Routes = [
  {
    path: '/onboarding',
    view: OnboardingSteps,
    layout: 'auth',
    permission: 'user',
    title: 'Welcome',
  },
  {
    path: '/signup',
    view: Signup,
    layout: 'auth',
    title: 'SignUp | SalesBlink',
  },
  {
    path: '/signup/oauth-redirect',
    view: OauthRedirect,
    layout: 'auth',
    title: 'Oauth Redirect',
  },
  {
    path: '/signup/phone',
    view: PhonePage,
    layout: 'app',
    permission: 'user',
    title: 'Dashboard',
  },
  {
    path: '/signup/user',
    view: SignupUser,
    layout: 'auth',
    title: 'Sign up to SalesBlink',
  },
  {
    path: '/signin',
    view: Signin,
    layout: 'auth',
    title: 'SignIn | SalesBlink',
  },
  {
    path: '/signin/otp',
    view: SigninOTP,
    layout: 'auth',
    title: 'Enter verification code',
  },
  {
    path: '/signin/social',
    view: SocialSignin,
    layout: 'auth',
    title: 'Completing Sign In',
  },
  {
    path: '/magic',
    view: MagicSignin,
    layout: 'auth',
    title: 'Sign In',
  },
  {
    path: '/forgotpassword',
    view: ForgotPassword,
    layout: 'auth',
    title: 'Forgot Password | SalesBlink',
  },
  {
    path: '/resetpassword',
    view: ResetPassword,
    layout: 'auth',
    title: 'Reset Your Password',
  },
  {
    path: '/signin/impersonate',
    view: ImpersonateSignin,
    layout: 'auth',
    title: 'Sign in via Mission Control',
  },
];

export default Routes;
